export const ThemeVariablesPrefixes = {
  Color: "color",
}
